import { render, staticRenderFns } from "./businessPlanList.vue?vue&type=template&id=1ff36c9a"
import script from "./businessPlanList.vue?vue&type=script&lang=js"
export * from "./businessPlanList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports